import { Outlet } from "react-router-dom";
import Sidebar from "../../../components/Sidebar";
import { Container } from "@mantine/core";

export default function Dashboard() {
  return (
    <div style={{ display: "flex" }}>
      <Sidebar />
      <main style={{ marginLeft: "260px", flex: 1, minHeight: "100vh", background: "#fafafa" }}>
        <Container size="xl" py="xl">
          <Outlet />
        </Container>
      </main>
    </div>
  );
}
